import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { siteWide } from '@helpers/grid';
import { Device, until } from '@helpers/media';
import { h2, headingStyles, paragraphRegular } from '@helpers/typography';
import { ButtonStyles } from '@stories/Components/Buttons/GeneralButton/Button.styles';
import UmbracoFormStyles from '@stories/Components/UmbracoForm/UmbracoForm.styles';
import styled from 'styled-components';
const Container = styled.footer `
  padding: 45px 0 60px;
`;
const Inner = styled.div `
  ${siteWide};
`;
const Grid = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: ${fluid(24, 32)};
  justify-content: space-between;

  @media ${until(Device.Tablet)} {
    justify-content: flex-start;
    row-gap: 35px;
  }
`;
const LeftCol = styled.div `
  @media ${until(Device.Tablet)} {
    flex: 1 0 100%;
  }
`;
const NewsletterArea = styled.div `
  margin-bottom: ${fluid(24, 32)};
  position: relative;
`;
const NewsletterTitle = styled.h2 `
  ${h2}
  margin-bottom: 16px;
`;
const NewsletterContent = styled.div `
  ${paragraphRegular};
  font-size: ${fluid(14, 16)};
  margin-bottom: 16px;
`;
const NewsletterForm = styled.div `
  ${UmbracoFormStyles.Form} {
    position: relative;
  }

  ${UmbracoFormStyles.Input} {
    padding-right: 40px;
  }

  ${UmbracoFormStyles.Submit} {
    margin: 0;
    position: absolute;
    right: 5px;
    top: 3px;

    ${ButtonStyles.Button}.is-submitting {
      ${ButtonStyles.Text} {
        svg {
          display: none;
        }
      }

      ${ButtonStyles.IconWrapper} {
        position: relative;
        top: 1px;
        left: 1px;
      }
    }
  }

  ${ButtonStyles.Button} {
    padding: 0;
    width: 35px;
    height: 35px;
  }

  ${ButtonStyles.Text} {
    svg {
      height: 10px;
    }
  }
`;
const SocialArea = styled.div `
  display: flex;
  gap: 24px;
`;
const SocialLink = styled.a `
  ${transition('color')};
  color: ${brand.primary.beige};

  &:hover,
  &:active {
    color: ${brand.primary.beigeLight};
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-color: ${brand.white};
  }

  svg {
    height: 20px;
  }
`;
const MenuCol1 = styled.div `
  display: flex;
  flex-direction: column;

  @media ${until(Device.Tablet)} {
    flex: 0 0 30%;
  }
`;
const MenuCol2 = styled.div `
  display: flex;
  flex-direction: column;

  @media ${until(Device.Tablet)} {
    flex: 1 0 40%;
  }
`;
const MenuLinkItem = styled.div ``;
const MenuLink = styled.a `
  ${headingStyles};
  display: block;
  color: ${brand.white};
  font-size: ${fluid(12, 14)};
  text-decoration: none;

  &:hover,
  &:active {
    text-decoration: underline;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-color: ${brand.white};
  }
`;
const FooterStyles = {
    Container,
    Grid,
    Inner,
    LeftCol,
    MenuCol1,
    MenuCol2,
    MenuLink,
    MenuLinkItem,
    NewsletterArea,
    NewsletterContent,
    NewsletterForm,
    NewsletterTitle,
    SocialArea,
    SocialLink,
};
export default FooterStyles;
